import moment from "moment";
import { Colour_Tournament } from "./Utils";

export class GameScoresBug {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
    createPage,
    setPageSummary,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.createPage = createPage;
    this.setPageSummary = setPageSummary;
    this.name = "GameScoresBug";
    this.scene = "GameScoresBug";
    this.data = [];
    this.downloadPage = 7009;
    this.page = 150;
    this.buildPage = 150;
  }

  async preview({ options }) {
    this.onAir = false;

    if (!options.build) {
      this.page = options.page;
      options.build = true;
      await this.buildSingle(options);
      await this.sendPreview("page:read " + this.page);
    } else {
      this.page = this.buildPage;
      await this.buildAll(options);
      this.page = this.buildPage;
      await this.sendPreview("page:read " + this.page);
    }
  }

  async buildSingle(options) {
    let xml = await this.getVizPage({ page: this.page });
    if (xml === "") {
      xml = await this.getVizPage({ page: this.downloadPage });
    }
    xml = Colour_Tournament({ game: options.game, xml });

    xml.payload.field.find((item) => {
      return item.attr.name === "0004"; // home team
    }).value = options?.game?.opta_scores?.status === "Result" ? "2" : "3";

    xml.payload.field.find((item) => {
      return item.attr.name === "101"; // home team
    }).value = options?.game?.home_team?.short_name;

    xml.payload.field.find((item) => {
      return item.attr.name === "100"; // home team
    }).value = options?.game?.home_team?.variables?.badge;

    xml.payload.field.find((item) => {
      return item.attr.name === "102"; // home team
    }).value = options?.game?.opta_scores?.home?.score;

    xml.payload.field.find((item) => {
      return item.attr.name === "301"; // home team
    }).value = options?.game?.away_team?.short_name;
    xml.payload.field.find((item) => {
      return item.attr.name === "300"; // home team
    }).value = options?.game?.away_team?.variables?.badge;
    xml.payload.field.find((item) => {
      return item.attr.name === "302"; // home team
    }).value = options?.game?.opta_scores?.away?.score;
    let text =
      options?.game?.opta_scores?.status === "Halftime"
        ? "Half Time"
        : options?.game?.opta_scores?.status === "First half" ||
          options?.game?.opta_scores?.status === "Second half"
        ? "Latest Score"
        : options?.game?.opta_scores?.status === "Result"
        ? "Full Time"
        : "";
    xml.payload.field.find((item) => {
      return item.attr.name === "0000104"; // home team
    }).value = text;

    if (options.build) {
      await this.updateVizPage({
        page: this.page,
        data: xml,
        escape: false,
      }).then(async (data) => {
        if (data === "") {
          await this.createPage({
            page: this.page,
            data: xml,
          });
        }
        this.setPageSummary({
          page: this.page,
          summary: text,
        });
      });
    } else {
      await this.updateVizPage({ page: this.page, data: xml, escape: false });
    }
  }

  async buildAll(options) {
    for (let i = 0; i < options?.games?.length; i++) {
      this.page = this.buildPage + i;
      let game = options?.games?.[i];
      await this.buildSingle({ game, build: true });
    }
  }

  animate({ options }) {
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }
}
